var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination",class:`pagination--default`},_vm._l((_vm.slides),function(slide){return _c('div',{key:`dot-${slide}`,staticClass:"pagination__dot",class:[
      `pagination__dot--${_vm.inactiveColor}`,
      { 'pagination__dot--ACTIVE': _vm.isActive(slide) }
    ],on:{"click":function($event){return _vm.$emit('click', slide)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }